import { SfTabs, SfLoader, SfReview, SfRating, } from '@storefront-ui/vue';
import { ref, computed, defineComponent, onMounted, } from '@nuxtjs/composition-api';
import reviewGetters from '~/modules/review/getters/reviewGetters';
import { useReview } from '~/modules/review/composables/useReview';
export default defineComponent({
    name: 'MyReviews',
    components: {
        SfLoader,
        SfReview,
        SfTabs,
        SfRating,
    },
    setup() {
        const { loading, loadCustomerReviews } = useReview();
        const reviews = ref(null);
        const userReviews = computed(() => reviewGetters.getItems(reviews.value));
        onMounted(async () => {
            // @ts-expect-error loadCustomerReviews type is wrong in theme and in api-client, see M2-579
            reviews.value = await loadCustomerReviews();
        });
        return {
            reviewGetters,
            userReviews,
            loading,
            loadCustomerReviews,
        };
    },
});
